import useSaleSummary from "../../../../hooks/use-sale-summary";
import StatCard from "../../../../components/StatCard";
import { StatSummary } from "../../../../components/StatSummary";
import Grid from "@mui/material/Grid";
import ChartCard from '../../../../components/chart/chart-card';
import SingleBarChart from '../../../../components/chart/single-bar-chart';
import { CURRENCY } from '../../../../shared/constants';
import LinesChart from '../../../../components/chart/line-chart';
import { KeyValuePair } from '../../../../model/key-value-pair';
import { LocalGroceryStoreIcon } from "../../../../shared/icons";

type SaleVsProfitChartData = {
    month: string;
    sales: number;
    profit: number;
};

function mergeSalesAndProfit(
    sales: KeyValuePair<number>[],
    profit: KeyValuePair<number>[]
): SaleVsProfitChartData[] {
    const map = new Map<string, SaleVsProfitChartData>();

    // add sales
    sales.forEach(({ key, value }) => {
        map.set(key, { month: key, sales: value, profit: 0 });
    });

    // add profit
    profit.forEach(({ key, value }) => {
        const existing = map.get(key);
        if (existing) {
            existing.profit = value;
        } else {
            map.set(key, { month: key, sales: 0, profit: value });
        }
    });

    return Array.from(map.values());
}

const SaleSummary = () => {
    const saleSummary = useSaleSummary();

    return (
        <div>
            {saleSummary &&
                <>
                    <StatSummary>
                        <StatCard title={`Sales - Last 30 Days (${CURRENCY})`} value={saleSummary?.thisMonthSales.toString()} icon={LocalGroceryStoreIcon} />
                        <StatCard title={`Profit - Last 30 Days (${CURRENCY})`} value={saleSummary?.thisMonthProfit.toString()} icon={LocalGroceryStoreIcon} />
                        <StatCard title="Quantity Sold Today" value={saleSummary?.itemsSoldToday.toString()} icon={LocalGroceryStoreIcon} />
                        <StatCard title={`Sales - Today (${CURRENCY})`} value={saleSummary?.todaySales.toString()} icon={LocalGroceryStoreIcon} />
                    </StatSummary>
                    <Grid container direction="row" justifyContent="flex-start">        
                        <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard>
                                <LinesChart
                                    data={mergeSalesAndProfit(saleSummary.salesTrend, saleSummary.profitTrend)}
                                    label={`Sales vs Profit (${CURRENCY}) - Last 12 Months`}
                                    xAxisKey="month"
                                    height={204}
                                    lines={[
                                        { dataKey: 'sales', name: 'Sales', stroke: '#1409ebff' },
                                        { dataKey: 'profit', name: 'Profit', stroke: '#188b45ff' },
                                    ]}
                                />
                            </ChartCard>
                        </Grid>
                        <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard>
                                <SingleBarChart
                                    data={saleSummary.profitableProducts.map(item => { return { name: item.key, value: item.value } })}
                                    label={`Most Profitable Products (${CURRENCY}) - Last 12 Months`}
                                    height={204}
                                    xAxisAngle={-90}
                                    xAxisLabelLimit={3}
                                />
                            </ChartCard>
                        </Grid>
                    </Grid>
                </>
            }
        </div>
    )
}

export default SaleSummary;